import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
// import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import { Grid, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from 'src/assets/illustrations';
//
import Iconify from '../iconify';
//
import RejectionFiles from './errors-rejection-files';
import MultiFilePreview from './preview-multi-file';
import SingleFilePreview from './preview-single-file';

// ----------------------------------------------------------------------

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const getFilesFromEvent = isIOS()
  ? async (event) => {
      return new Promise((resolve) => {
        const files = Array.from(event.target.files || event.dataTransfer.files);
        const updatedFiles = files.map(file => {
          const newName = `${Date.now()}-${file.name}`;
          const renamedFile = new File([file], newName, {
            type: file.type,
            lastModified: file.lastModified,
          });

          // Make path the same as the renamed file's name
          renamedFile.path = renamedFile.name;

          return renamedFile;
        });
        resolve(updatedFiles);
      });
    }
  : undefined;
export default function UploadSMCD({
  disabled,
  multiple = false,
  error,
  helperText,
  //
  file,
  onDelete,
  //
  files,
  thumbnail,
  onUpload,
  onRemove,
  onRemoveAll,
  onClick,
  setImageDialog,
  setValue,
  sx,
  accept,
  ...other
}) {
  // Convert accept string to object format if needed (for better browser compatibility)
  const acceptFormat = typeof accept === 'string' 
    ? accept === 'image/*' 
      ? { 'image/*': [] }
      : { [accept]: [] }
    : accept;

  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple,
    disabled,
    type: "file",
    maxSize: 21 * 1024 * 1024,
    accept: acceptFormat,
    ...other,
    ...(getFilesFromEvent ? { getFilesFromEvent } : {})
  });

  // Override input props to ensure no capture attribute is set
  // This allows Android devices to show the camera/gallery choice like iOS
  const inputProps = getInputProps();
  const inputPropsWithoutCapture = {
    ...inputProps,
    capture: undefined, // Explicitly remove capture to allow camera/gallery choice on Android
  };

 // resolve(multiple ? updatedFiles : updatedFiles[0]);
  
  const hasFile = !!file && !multiple; 
  const hasFiles = !!files && multiple && !!files.length;
  const hasError = isDragReject || !!error;

  const renderPlaceholder = (
  <></>
  );

  const renderSinglePreview = (
    <>
    <SingleFilePreview imgUrl={typeof file === 'string' ? file : file?.preview} />
    </>
  );

  const removeSinglePreview = hasFile && onDelete && (
    <IconButton
      size="small"
      onClick={onDelete}
      sx={{
        top: 16,
        right: 16,
        zIndex: 9,
        position: 'absolute',
        color: (theme) => alpha(theme.palette.common.white, 0.8),
        bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
        '&:hover': {
          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48),
        },
      }}
    >
      <Iconify icon="mingcute:close-line" width={18} />
    </IconButton>
  );

  const renderMultiPreview = hasFiles && (
    <>
      <Box sx={{ my: 3 }}>
    
        <MultiFilePreview
          files={files}
          thumbnail={thumbnail}
          onRemove={onRemove}
          onClick={onClick && typeof onClick === 'function' ? onClick : undefined}
          setImageDialog={setImageDialog}
          setValue={setValue}
          onRemoveAll={onRemoveAll}
        />
      </Box>

      <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
        {onRemoveAll && (
          <Button color="inherit" variant="outlined" size="small" onClick={onRemoveAll}>
            Remove All
          </Button>
        )}

      </Stack>
    </>
  );

  return (
    <Box sx={{ width: 1, position: 'relative', ...sx }} className="uplodImgcmp">
      <Box
        {...getRootProps()}
      >
        <input {...inputPropsWithoutCapture} type="file" />

        {hasFile ? renderSinglePreview : renderPlaceholder}
      </Box>

      {removeSinglePreview}

      {helperText && helperText}

      <RejectionFiles fileRejections={fileRejections} customRejections={other.customRejections || []} />

      {renderMultiPreview}
    </Box>
  );
}
